var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacialmodeWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.427,
    height: 43.427,
    viewBox: "0 0 43.427 43.427",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-face-id-5433003",
    transform: "translate(-116.666 -46.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_28241",
    "data-name": "\\u30D1\\u30B9 28241",
    d: "M123.184,46.668a6.514,6.514,0,0,0-6.514,6.514V58.61a2.171,2.171,0,1,0,4.342,0V53.182a2.172,2.172,0,0,1,2.172-2.172h5.428a2.171,2.171,0,0,0,0-4.342Z",
    transform: "translate(-0.004)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_28242",
    "data-name": "\\u30D1\\u30B9 28242",
    d: "M433.839,46.668a2.171,2.171,0,1,0,0,4.342h5.428a2.172,2.172,0,0,1,2.172,2.172V58.61a2.171,2.171,0,0,0,4.343,0V53.182a6.514,6.514,0,0,0-6.514-6.514Z",
    transform: "translate(-285.688)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_28243",
    "data-name": "\\u30D1\\u30B9 28243",
    d: "M121.008,363.839a2.171,2.171,0,1,0-4.342,0v5.428a6.514,6.514,0,0,0,6.514,6.514h5.428a2.171,2.171,0,1,0,0-4.342H123.18a2.172,2.172,0,0,1-2.172-2.172Z",
    transform: "translate(0 -285.686)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_28244",
    "data-name": "\\u30D1\\u30B9 28244",
    d: "M445.78,363.839a2.171,2.171,0,1,0-4.343,0v5.428a2.172,2.172,0,0,1-2.172,2.172h-5.428a2.171,2.171,0,0,0,0,4.342h5.428a6.514,6.514,0,0,0,6.514-6.514Z",
    transform: "translate(-285.686 -285.686)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_28245",
    "data-name": "\\u30D1\\u30B9 28245",
    d: "M200.132,116.67a13.462,13.462,0,1,0,13.462,13.462A13.462,13.462,0,0,0,200.132,116.67ZM193.777,132.5a1.923,1.923,0,0,1,2.708.254,4.495,4.495,0,0,0,7.295,0,1.923,1.923,0,0,1,2.962,2.454,8.33,8.33,0,0,1-13.219,0,1.924,1.924,0,0,1,.254-2.708Z",
    transform: "translate(-61.992 -61.323)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacialmodeWhite);
export default __webpack_public_path__ + "static/media/facialmodeWhite.6560be4b35a675967c06fab4dd9d7b03.svg";
export { ForwardRef as ReactComponent };